import {
  IOrganization,
  IOrganizationDocuments,
  IOrganizationDocumentsData,
  IOrganizationLegalEntity,
  ORGANIZATIONS_STATUS,
  ORGANIZATIONS_TYPE,
} from 'api/organizations/types';
import { TObject } from 'utils/types';

export const normalizeOrganization = (data: TObject): IOrganization => {
  return {
    callbackUrl: (data?.callbackUrl as string) || null,
    created: (data?.created as string) || '',
    id: (data?.id as number) || 0,
    ipWhitelistMp: (data?.ipWhitelistMp as string)?.split(';') || [],
    lastPurchaseDate: (data?.lastPurchaseDate as string) || '',
    name: (data?.name as string) || '',
    portalDomain: (data?.portalDomain as string) || '',
    proxyDomain: (data?.proxyDomain as string) || '',
    status: (data?.status as ORGANIZATIONS_STATUS) || '',
    supportEmail: (data?.supportEmail as string) || '',
    type: (data?.type as ORGANIZATIONS_TYPE) || '',
  };
};

export type IOrganizationLegalEntityData = TObject & {
  assignedMerchantTerminals?: TObject[];
  unassignedMerchantTerminals?: TObject[];
};

export const normalizeTransferEntity = (data: TObject) => ({
  label: (data?.name as string) || '',
  value: (data?.id as number) || 0,
});

export const normalizeLegalEntity = (data: TObject) => {
  return {
    address: (data?.address as string) || '',
    ceoEmail: (data?.ceoEmail as string) || '',
    countryCode: (data?.countryCode as string) || '',
    created: (data?.created as string) || '',
    financeEmail: (data?.financeEmail as string) || '',
    id: (data?.id as number) || 0,
    name: (data?.name as string) || '',
    registrationNumber: (data?.registrationNumber as string) || '',
    vat: (data?.vat as string) || '',
    vatRate: data?.vatRate as number,
  };
};

export const normalizeOrganizationLegalEntity = (
  data: IOrganizationLegalEntityData,
): IOrganizationLegalEntity => {
  return {
    ...normalizeLegalEntity(data),
    assignedMerchantTerminals:
      data?.assignedMerchantTerminals?.map(normalizeTransferEntity) || [],
    unassignedMerchantTerminals:
      data?.unassignedMerchantTerminals?.map(normalizeTransferEntity) || [],
  };
};

export const normalizerOrganizationDocument = (
  data: IOrganizationDocumentsData,
): IOrganizationDocuments => {
  return {
    created: (data?.created as string) || '',
    fileName: (data?.fileName as string) || '',
    hqLegalEntity: normalizeOrganizationLegalEntity(data?.hqLegalEntity),
    id: (data?.id as number) || 0,
    size: (data?.size as number) || 0,
  };
};
